export enum EField {
  IBAN = "iban",
  OwnerName = "ownerName",
}

export interface IExtraData {
  ownerName?: string;
  showHeader?: boolean;
  iban?: string;
  validateSepaSupported: boolean;
}
